export default {
	message_arrived: "쪽지가 도착하였습니다.",
	answer_arrived: "답변이 도착하였습니다.",
	notice_arrived: "공지가 도착하였습니다.",
	deposit_rejected: "충전신청이 거절되었습니다.",
	deposit_approved: "충전신청이 승인되었습니다.",
	withdrawal_approved: "환전신청이 승인되었습니다.",
	withdrawal_denied: "환전신청이 거절되었습니다.",
	balance_deducted: "보유머니가 차감되었습니다.",
	balance_credited: "보유머니가 지급되었습니다.",
	point_deducted: "포인트가 차감되었습니다.",
	point_credited: "포인트가 지급되었습니다.",
    money_increase: "보유머니 증가",
	money_decrease: "보유머니 차감",
	point_increase: "포인트 증가",
	point_decrease: "포인트 차감",
	loosing_increase: "루징머니 증가",
	loosing_decrease: "루징머니 차감",
	point_exchange: "포인트전환",
	to_money: "보유머니로전환",
    format_withdraw_request: "{param1}님 환전요청",
	format_approved_deposit: "{param1}님 충전요청승인됨",
	format_decreased_money_withreason: "{param1}님에게서 보유금액 차감, 변경사유: {param2}",
	format_decrease_money_withreason: "{param1}({param2})님이 보유금액 차감, 변경사유: {param3}",
	format_increased_money_withreason: "{param1}님에게 보유금액 지급, 변경사유: {param2}",
	format_increase_money_withreason: "{param1}({param2})님이 보유금액 지급, 변경사유: {param3}",
	format_decreased_point_withreason: "{param1}님에게서 포인트 차감, 변경사유: {param2}",
	format_decrease_point_withreason: "{param1}({param2})님이 포인트 차감, 변경사유: {param3}",
	format_increased_point_withreason: "{param1}님에게 포인트 지급, 변경사유: {param2}",
	format_increase_point_withreason: "{param1}({param2})님이 포인트 지급, 변경사유: {param3}",
	format_increase_point_bybonsa_withreason: "본사(본사)님이 포인트 지급, 변경사유: 개발실 지급",
	format_decrease_point_bybonsa_withreason: "본사(본사)님이 포인트 회수, 변경사유: 개발실 회수",
	format_bet_betgame: "{param1}님 벳게임 {param2} 베팅",
	format_bet_minigame: "{param1}님 미니게임 {param2} 베팅",
	format_win: "{param1}({param2}) 베팅당첨",
	format_bet: "{param1}({param2}) 베팅",
	format_user_bet: "{param1} 님 {param2}({param3}) 베팅",
	format_user_detail_bet: "{param1}님 {param2} GAME {param3} {param4} 베팅",
	format_user_detail_refund: "{param1}님 {param2} GAME {param3} {param4} 환불",
	format_betcancel: "{param1}({param2}) 베팅취소",
	format_adjust: "{param1}({param2}) 베팅결과조정",
	format_tie: "{param1}({param2}) 베팅타이",
	format_loss: "{param1}({param2}) 베팅낙첨",
	format_bonus: "{param1}({param2}) 보너스",
	format_user_kplay_bet_rolling: "{param1}님 {param2} 케플인플레이 베팅롤링",
	format_kplay_loss_rolling: "{param1}님 케플인플레이 낙첨롤링",
	format_manual_restore_decrease: "{param1} 복원수동처리에 의한 회수",
	format_sport_rolling: "{param1}님 스포츠 롤링",
	format_loss_rolling: "{param1}님 낙첨 롤링",
	format_sport_refund: "{param1}님 스포츠 환불",
	format_user_betgame_refund: "{param1}님 BET GAME {param2} 환불",
	format_decrease_event_bonus_dueto_deposit_cancel: "{param1}님에 의해 충전승인취소에 의한 충전이벤트보너스 회수",
	format_decrease_coupon_bonus_dueto_deposit_cancel: "{param1}님에 의해 충전승인취소에 의한 충전쿠폰보너스 회수",
	format_decrease_firstdeposit_bonus_dueto_deposit_cancel: "{param1}님에 의해 충전승인취소에 의한 첫충/매충보너스 회수",
	format_decrease_deposit_money_dueto_deposit_cancel: "{param1}님에 의해 충전승인취소에 의한 충전금액 회수",
	format_increase_point_dueto_register_firstdeposit_bonus: "{param1}님 가입첫충전보너스 {param2}% 해당한 포인트 받음",
	format_increase_point_dueto_today_firstdeposit_bonus: "{param1}님 금일첫충전보너스 {param2}% 해당한 포인트 받음",
	format_increase_point_dueto_every_firstdeposit_bonus: "{param1}님 매충전보너스 {param2}% 해당한 포인트 받음",
	format_increase_point_dueto_event_depsit_bonus: "{param1}님 이벤트충전보너스 {param2}% 해당한 포인트 받음",
	format_increase_point_dueto_continuous_attendance: "{param1}일 {param2}님 출석보너스포인트 받음",
	format_incraase_money_dueto_using_deposit_coupon: "{param1}님 충전쿠폰 사용. 내역상세: 충전금액: {param2}, 쿠폰보너스: {param3}%",
	format_cancel_withdrawal: "{param1}님에 의해 환전승인 취소됨",
	format_deny_withdrawal: "{param1}님 환전요청 불허됨",
	format_increase_point_dueto_deposit_bonus: "{param1}님 충전보너스포인트 받음",
	format_manual_betting_cancel: "{param1}업체에 의한 {param2} 베팅 수동취소",
	format_manual_betting_win: "{param1}업체에 의한 {param2} 베팅 수동당첨",
	format_cancel_by_enterprise: "{param1}업체에 의한 {param2} 취소",
	format_game_by_enterprise: "{param1}업체에 의한 {param2}님 {param3}",
	format_user_game: "{param1}님 {param2}",
	format_user_rolling: "{param1}님 {param2}롤링",
	format_user_loss_rolling: "{param1}님 {param2} 낙첨롤링",
	format_user_coupon_usage: "{param1}님 쿠폰사용",
	format_user_lottery_win: "{param1}님 복권당첨",
	format_user_roulette_win: "{param1}님 룰렛당첨",
	format_bet_refunded: "베팅 ({param1}원)이 환불되었습니다.",
	format_bet_lost: "베팅 ({param1}원)이 낙첨되었습니다.",
	format_bet_win: "베팅 ({param1}원)이 {param2}원 당첨되었습니다."
};


// WEBPACK FOOTER //
// ./src/locales/ko-KR.js